export const INVOICING_SETTINGS_SIDE_NAV_WIDTH = 200
